import Vue from 'vue';
//import VueFire from 'vuefire'
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

//Vue.use(VueFire);

import { firestorePlugin } from 'vuefire';
Vue.use(firestorePlugin);

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyCi9eiuBEroSfnElfBZsXCILeRrgJPQjxw",
  authDomain: "recibase-20201021.firebaseapp.com",
  databaseURL: "https://recibase-20201021.firebaseio.com",
  projectId: "recibase-20201021",
  storageBucket: "recibase-20201021.appspot.com",
  messagingSenderId: "551028035943",
  appId: "1:551028035943:web:db0e3ad20d016b416cdfc2",
  measurementId: "G-RQPD5565HG"
});

export const db = firebaseApp.firestore();

export const auth = firebaseApp.auth();

export const fieldValue = firebase.firestore.FieldValue;